import { render } from "./Navbar.vue?vue&type=template&id=27fd74aa&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=27fd74aa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/company-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fd74aa"]])

export default __exports__